// extracted by mini-css-extract-plugin
export var legendIndicator = "_bi-1";
export var legendRight = "_bi-0";